<template>
  <div class="not-found-container">
    <el-result
      icon="warning"
      :title="$t('notFound.title')"
      :sub-title="$t('notFound.subTitle')"
    >
      <template slot="extra">
        <el-button type="primary" size="medium" @click="goHome">{{
          $t("notFound.button")
        }}</el-button>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.not-found-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
</style>
